import { GetActivoByIdDtoProps } from "api/DTOs/GetActivoByIdDto"
import { ErrorMessage, Field, FormikHandlers } from "formik"
import { TFunction } from "i18next"

interface ProviderDetailProps {
  handleChange: FormikHandlers["handleChange"]
  values: Partial<GetActivoByIdDtoProps>
  t: TFunction
}
export const ProviderDetail = ({
  handleChange,
  values,
  t,
}: ProviderDetailProps) => (
  <div className='tw-grid tw-grid-cols-4 tw-gap-4'>
    <div className='tw-col-span-4 tw-text-left tw-font-medium'>
      {t("nsAssets.tabDetails.providerDetails")}
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='proveedor.razonSocial'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.companyName")}
      </label>
      <Field
        name='proveedor.razonSocial'
        type='text'
        id='proveedor.razonSocial'
        className='tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed tw-border-neutral-25'
        onChange={handleChange}
        value={values?.proveedor?.razonSocial ?? ""}
        disabled
      />
      <ErrorMessage
        name='proveedor.razonSocial'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-1 tw-text-left'>
      <label
        htmlFor='proveedor.nif'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.nif")}
      </label>
      <Field
        name='proveedor.nif'
        type='text'
        id='proveedor.nif'
        className='tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed tw-border-neutral-25'
        onChange={handleChange}
        value={values?.proveedor?.nif ?? ""}
        disabled
      />
      <ErrorMessage
        name='proveedor.nif'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-1 tw-text-left'>
      <label
        htmlFor='proveedor.factura'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.invoice")}
      </label>
      <Field
        name='proveedor.factura'
        type='text'
        id='proveedor.factura'
        className='tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed tw-border-neutral-25'
        onChange={handleChange}
        value={values?.proveedor?.factura ?? ""}
        disabled
      />
      <ErrorMessage
        name='proveedor.factura'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
  </div>
)
